export const menu = [
  {
    pathName: 'Dashboard',
    path: '/',
    icon: 'LayoutDashboard',
  },
  {
    pathName: 'Organizations',
    path: '/organizations',
    icon: 'Hotel',
  },
  {
    pathName: 'Stripe',
    path: '/stripe',
    icon: 'CreditCard',
  },
  {
    pathName: 'Organizations Group',
    path: '/organizations-group',
    icon: 'Group',
  },
  {
    pathName: 'Users',
    path: '/users',
    icon: 'Users',
  },
  {
    pathName: 'Attractions',
    path: '/attractions',
    icon: 'Globe',
  },
  {
    pathName: 'InMails',
    path: '/inmails',
    icon: 'Mail',
  },
  {
    pathName: 'Reklamy',
    path: '/ads',
    icon: 'Megaphone',
  },
  {
    pathName: 'Zgłoszenia',
    path: '/client-requests',
    icon: 'LifeBuoy',
  },
  {
    pathName: 'Languages',
    path: '/languages',
    icon: 'Languages',
  },
  {
    pathName: 'Ads Generator',
    path: '/ads-generator',
    icon: 'Sparkles',
  },
  {
    pathName: 'Użycie AI',
    path: '/ai-usage',
    icon: 'Gauge',
  },
  {
    pathName: 'Cennik AI',
    path: '/ai-pricing',
    icon: 'Coins',
  },
  {
    pathName: 'Service',
    path: '/service',
    icon: 'Wrench',
  },
  // {
  //   pathName: 'Release notes',
  //   path: '/release-notes',
  //   icon: 'Newspaper',
  // },
  // {
  //   pathName: 'Logs',
  //   path: '/logs',
  //   icon: 'FileClock',
  // },
  {
    pathName: 'Pod\'s',
    path: '/devices',
    icon: 'MonitorDot',
    hasDivider: true,
  },
  {
    pathName: 'SDLC Orchestrator',
    path: 'https://mac-mini-admin.taildfe856.ts.net:8443/',
    icon: 'Workflow',
    isExternal: true,
  },
  {
    pathName: 'Outreach Manager',
    path: 'https://mac-mini-admin.taildfe856.ts.net/',
    icon: 'Send',
    isExternal: true,
  },
  {
    pathName: 'Jira Board',
    path: 'https://hotelspot.atlassian.net/jira/software/projects/HS/boards/1',
    icon: 'SquareKanban',
    isExternal: true,
  },
  {
    pathName: 'API Docs',
    path: 'https://hotelspot-api.web.app/',
    icon: 'BookOpen',
    isExternal: true,
  },
  // {
  //   pathName: 'TV\'s',
  //   path: '/tv',
  //   icon: 'Tv',
  // },

  // {
  //   pathName: 'Translation Status',
  //   path: '/translation-status',
  //   icon: 'Languages',
  // },
  // {
  //   pathName: 'Settings',
  //   path: '/settings',
  //   icon: 'Settings',
  // },
];

// Ścieżki widoczne dla admina z zawężonym dostępem (claim `adminPermission`).
const ADMIN_PERMISSION_PATHS: Record<string, string[]> = {
  onlyAttraction: ['/organizations', '/attractions'],
  onlySupport: ['/client-requests'],
  // Pulpit zostaje, bo to strona startowa po zalogowaniu; poza nim widać
  // wyłącznie generator reklam.
  onlyAdsGenerator: ['/', '/ads-generator'],
};

/**
 * Zawęża menu do zakładek dozwolonych dla danego `adminPermission`.
 * Brak zawężenia (albo nieznana wartość) = pełne menu.
 */
export const filterMenuByAdminPermission = <T extends { path: string }>(
  items: T[],
  adminPermission?: string,
): T[] => {
  const allowed = adminPermission ? ADMIN_PERMISSION_PATHS[adminPermission] : undefined;
  if (!allowed) return items;
  return items.filter((item) => allowed.includes(item.path));
};
